export function getDisplayName(
    user: { username: string; display_name?: string | null } | undefined,
    nickname?: string | null,
): string {
    return (
        nickname ??
        user?.display_name ??
        user?.username ??
        "Неизвестный пользователь"
    );
}
